import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowser } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

if (environment.sentry.enabled) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: environment.releaseVersion,
    integrations: [
      Sentry.browserSessionIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Optional privacy settings:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracePropagationTargets: environment.sentry.tracingOrigins,
    // /* ⚠️ IMPORTANT: UPGRADE REQUIRED ⚠️
    //  * This beforeSendSpan approach is for Sentry v8.x only.
    //  * When upgrading to Sentry v10.2.0+, replace with ignoreSpans configuration:
    //  *
    //  * ignoreSpans: [
    //  *   { name: /^Zone:.*/ },
    //  *   { name: /productfruits\.com/ },
    //  *   { name: /cardtemplate\.html/ },
    //  * ]
    // */
    beforeSendSpan(span) {
      if (
        span.description?.startsWith('Zone:') ||
        span.description === 'Zone'
      ) {
        return null;
      }
      if (
        // span.description?.includes('app.productfruits.com') ||
        span.description?.includes('wilsonapp.matomo.cloud') ||
        // span.description?.includes('events.launchdarkly.com') ||
        // span.description?.includes('app.launchdarkly.com') ||
        span.description?.includes('cdn.talkjs.com') ||
        // span.description?.includes('maps.googleapis.com') ||
        span.description?.includes('mark_feature_usage')
      ) {
        return null;
      }

      return span;
    },
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,
  });
}

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
